import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/setting/app-module',
  title: '应用模块管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
